import React from "react";
import { NavLink, Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import {
  settingsTabBarBleedSx,
  settingsTabBarSx,
  settingsTabItemActiveSx,
  settingsTabItemSx,
  settingsScrollContainerSx,
  settingsScrollInnerSx,
} from "../shared/styles";

const ADMIN_TABS = [
  { key: "workspace-settings", label: "Workspace Settings" },
  { key: "plan-billing", label: "Plan & Billing" },
  { key: "custom-domain", label: "Custom Domain" },
  { key: "business-email", label: "Business Email" },
  { key: "chat-widget", label: "Chat Widget" },
  { key: "ticket-routing", label: "Ticket Routing" },
];

function SettingsV2AdminLayout() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flex: "1 1 0",
        minHeight: 0,
        maxHeight: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box sx={{ ...settingsTabBarSx, ...settingsTabBarBleedSx }}>
        {ADMIN_TABS.map((tab) => (
          <Box
            key={tab.key}
            component={NavLink}
            to={tab.key}
            end={false}
            style={{
              fontSize: "14px",
            }}
            sx={{
              ...settingsTabItemSx,
              "&.active": settingsTabItemActiveSx,
            }}
          >
            {tab.label}
          </Box>
        ))}
      </Box>

      <Box sx={settingsScrollContainerSx}>
        <Box sx={settingsScrollInnerSx}>
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
}

export default SettingsV2AdminLayout;
